import { render, staticRenderFns } from "./HorizontalNavMenuLink.vue?vue&type=template&id=e9d68d62&scoped=true&"
import script from "./HorizontalNavMenuLink.vue?vue&type=script&lang=js&"
export * from "./HorizontalNavMenuLink.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalNavMenuLink.vue?vue&type=style&index=0&id=e9d68d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d68d62",
  null
  
)

export default component.exports